import { GeoLocation } from '@pflegia/data-access';
import { calculateDistance } from '@pflegia/util/common/distance';

export const getSortedLocationsByDistance = (locations: GeoLocation[], origin: Pick<GeoLocation, 'formattedAddress' | 'location'>) => {
  const locationsWithDistance = locations.map(location => ({
    location,
    distance: calculateDistance(
      origin.location.coordinates?.[1],
      origin.location.coordinates?.[0],
      location.location.coordinates?.[1],
      location.location.coordinates?.[0],
    ),
  }));

  locationsWithDistance.sort((a, b) => a.distance - b.distance);

  return locationsWithDistance.map(item => item.location);
};
